// AUTOGENERATED: DO NOT EDIT

import { AnimatedSprite, Spritesheet, SpritesheetData, Texture } from "pixi.js";
import img from "../../assets/img/fish/clownfish.png";
import { SpriteSheetJSON } from "./type";

const data: SpriteSheetJSON = {
  frames: {
    "clownfish 0.aseprite": {
      frame: {
        x: 0,
        y: 0,
        w: 32,
        h: 32,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 32,
        h: 32,
      },
      sourceSize: {
        w: 32,
        h: 32,
      },
      duration: 100,
    },
    "clownfish 1.aseprite": {
      frame: {
        x: 32,
        y: 0,
        w: 32,
        h: 32,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 32,
        h: 32,
      },
      sourceSize: {
        w: 32,
        h: 32,
      },
      duration: 100,
    },
    "clownfish 2.aseprite": {
      frame: {
        x: 64,
        y: 0,
        w: 32,
        h: 32,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 32,
        h: 32,
      },
      sourceSize: {
        w: 32,
        h: 32,
      },
      duration: 100,
    },
    "clownfish 3.aseprite": {
      frame: {
        x: 96,
        y: 0,
        w: 32,
        h: 32,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 32,
        h: 32,
      },
      sourceSize: {
        w: 32,
        h: 32,
      },
      duration: 100,
    },
    "clownfish 4.aseprite": {
      frame: {
        x: 128,
        y: 0,
        w: 32,
        h: 32,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 32,
        h: 32,
      },
      sourceSize: {
        w: 32,
        h: 32,
      },
      duration: 100,
    },
    "clownfish 5.aseprite": {
      frame: {
        x: 160,
        y: 0,
        w: 32,
        h: 32,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 32,
        h: 32,
      },
      sourceSize: {
        w: 32,
        h: 32,
      },
      duration: 100,
    },
    "clownfish 6.aseprite": {
      frame: {
        x: 192,
        y: 0,
        w: 32,
        h: 32,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 32,
        h: 32,
      },
      sourceSize: {
        w: 32,
        h: 32,
      },
      duration: 100,
    },
  },
  meta: {
    app: "https://www.aseprite.org/",
    version: "1.3.9.2-arm64",
    image: "clownfish.png",
    format: "RGBA8888",
    size: {
      w: 224,
      h: 32,
    },
    scale: "1",
    frameTags: [],
    layers: [
      {
        name: "Group 1",
      },
      {
        name: "fish",
        group: "Group 1",
        opacity: 255,
        blendMode: "normal",
      },
      {
        name: "stripes",
        group: "Group 1",
        opacity: 255,
        blendMode: "normal",
      },
      {
        name: "Group 2",
        group: "Group 1",
      },
      {
        name: "mouth and nose",
        group: "Group 2",
        opacity: 255,
        blendMode: "normal",
      },
      {
        name: "eye",
        group: "Group 2",
        opacity: 255,
        blendMode: "normal",
      },
      {
        name: "Hat",
        group: "Group 1",
        opacity: 255,
        blendMode: "normal",
      },
    ],
    slices: [],
  },
  animations: {
    swim: [
      "clownfish 0.aseprite",
      "clownfish 1.aseprite",
      "clownfish 2.aseprite",
      "clownfish 3.aseprite",
      "clownfish 4.aseprite",
      "clownfish 5.aseprite",
      "clownfish 6.aseprite",
    ],
  },
};
export const clownfish = async () => {
  const texture = Texture.from(img);
  texture.source.scaleMode = "nearest";

  const spritesheet = new Spritesheet(texture, data as SpritesheetData);

  await spritesheet.parse();

  const swim = new AnimatedSprite(spritesheet.animations.swim);

  swim.width = 64;
  swim.height = 64;
  swim.anchor.set(0.5, 0.5);

  return swim;
};
